<h2 i18n="section.signInMethods.form.changeEmail.title">Enter your new e-mail address</h2>

<form [formGroup]="form" (ngSubmit)="onSubmit()" style="display: grid; gap: 12px; max-width: 420px;">
  <mat-form-field>
    <mat-label i18n="@@common.newEmail">New email</mat-label>

    <input matInput type="email" [formControlName]="ChangeEmailForm.FIELD_EMAIL">

    <mat-error *ngIf="form.get(ChangeEmailForm.FIELD_EMAIL)?.hasError('required')"
               i18n="@@common.validation.required">Required</mat-error>
    <mat-error *ngIf="form.get(ChangeEmailForm.FIELD_EMAIL)?.hasError('email')"
               i18n="@@common.validation.emailInvalid">Invalid email</mat-error>
  </mat-form-field>

  <div style="display:flex; gap:8px; align-items:center; justify-content: right;">
    <button mat-stroked-button
            type="button"
            (click)="onCancel()"
            [disabled]="submitting">
      <ng-container i18n="@@common.action.cancel">Cancel</ng-container>
    </button>

    <button mat-flat-button
            type="submit"
            color="primary"
            [disabled]="form.invalid || submitting">
      <ng-container *ngIf="!submitting" i18n="@@common.action.update">Update</ng-container>
      <ng-container *ngIf="submitting" i18n="@@common.action.updating">Updating…</ng-container>
    </button>
  </div>
</form>
